<template>
    <base-modal size="lg" hide-header hide-footer @close="close" >
        <div ref="content" style="overflow: hidden">
            <div
                v-if="!assignmentMode && observationUpdate"
                class="col-12 nopads"
                @click.stop="cancelClick($event)"
            >
            <div class="d-flex flex-column editor-form" style="height: 85vh; border-radius: .5em">
                <!-- Header with Street View link -->
                <header class="flex-shrink-0 border-bottom">
                    <div class="d-flex">
                        <div class="me-2">
                            <h2 class="editor-header px-1">{{ !observationUpdate || observationUpdate.id < 1 ?  $t('observations.add_observation') : $t('observations.edit_observation')}}</h2>
                        </div>
                        <div class="flex-grow-1 d-flex justify-content-end align-items-center">
                            <div
                                v-if="isObserver && observationUpdate"
                                class="form-check form-switch mx-2 px-2 pb-1 d-flex align-items-center"
                            >
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="'selection-toggle-' + observationUpdate.id"
                                    :checked="isSelected"
                                    @change="handleSelectionToggle"
                                />
                                <label
                                    class="form-check-label ms-2"
                                    :for="'selection-toggle-' + observationUpdate.id"
                                >
                                    {{ $t('observations.selected') }}
                                </label>
                            </div>
                            <google-street-view-link :latLon="getMapPoint(observationUpdate)"/>
                            <editor-item-browser :index="index" :item-count="itemCount" @nextItem="$emit('nextItem')" @previousItem="$emit('previousItem')"/>
                        </div>
                    </div>
                </header>
                <!-- Scrollable content -->
                <main class="flex-grow-1 overflow-auto px-1">
                    <div class="nopads px-2">
                    <draw-geometry-wizard
                        v-if="showDrawGeometryWizard !== false"
                        :savedGeometry="observationUpdate.geometry"
                        :observationMode="true"
                        :type="OTHER"
                        @close="closeDrawGeometryWizard"
                        @addDrawnGeometry="addGeometryToObservation"
                    />
                    <h3 v-if="observationUpdate && observationUpdate.id" class="pt-1">
                        {{ observation.type.name  }}
                    </h3>
                    <div class="row">
                        <road-addess-view v-if="!userDefinedGeometry && observation"
                            :road-number="observation.road_number"
                            :section-number="observation.section_number"
                            :distance="observation.distance_from_sec_start"
                            :street-name="observation.street_name"
                            :city="observation.city?.name"
                            :length="observation.length"
                        />
                    </div>
                    <div class="col-12">
                        <div>
                            <span class="span-title">{{ $t('observations.observation_group') }}</span>
                            <select
                                v-model="group"
                                class="form-select form-select-sm mb-0"
                            >
                                <option :value="null" disabled>
                                    {{ $t('observations.select_group') }}
                                </option>
                                <option
                                    v-for="item in groups"
                                    :key="item.id"
                                    :value="item.id"
                                >
                                    {{ item.name }}
                                </option>
                            </select>
                            <span class="span-title">{{ $t('observation_filter.observation_type') }}</span>
                            <select
                                v-model="observationUpdate.type"
                                class="form-select form-select-sm sm-3"
                                :disabled="!types"
                            >
                                <option :value="null" disabled>
                                    {{ $t('observation_filter.select_observation_type') }}
                                </option>
                                <option
                                    v-for="option in types"
                                    :key="option.id"
                                    :value="option"
                                >
                                    {{ option.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <!-- Location editable if observation is populated -->
                        <div class="col-sm-6 nopads pl-1 p-3 pt-1">
                            <div class="col-sm-12 stat-map-container nopads" style="overflow: hidden; height: 15em;">
                                <marker-editor-map
                                    ref="markerEditorMap"
                                    :id="observationUpdate.id"
                                    :lat="getLatitude(this.observationUpdate)"
                                    :lon="getLongitude(this.observationUpdate)"
                                    :points="getPoints(this.observationUpdate)"
                                    :type="OBSERVATION"
                                    :force-remove-previous-geometry="true"
                                    :observation-mode="true"
                                    :draggable="false"
                                />
                            </div>
                        </div>
                        <!-- PHOTOS -->
                        <div class="col-sm-6 nopads pl-1 p-3 pt-1">
                            <div class="stat-container nopads" style="overflow: hidden">
                                <Flicking ref="flicking" :options="options" :plugins="plugins" class="pointer nopads text-center"
                                          style="height: 15em;"
                                          v-if="observationUpdate.photos && observationUpdate.photos.length > 0"
                                >
                                        <template
                                            v-for="photo in observationUpdate.photos"
                                            :key="photo.id"
                                        >
                                            <ImageView
                                                ref="image"
                                                class="flicking-panel"
                                                :contain="true"
                                                :url="getPhotoUrl(observationPhotoUrl, photo)"
                                                @click="openImage"
                                                :controlSize="`sm`"
                                            />
                                        </template>
                                        <template #viewport>
                                            <span class="flicking-arrow-prev"></span>
                                            <span class="flicking-arrow-next"></span>
                                            <div class="flicking-pagination flicking-pagination-bullets-container" />
                                        </template>
                                </Flicking>
                                <div v-else
                                     style="padding-top: 6em; height: 15em; text-align: center">
                                    {{ $t('power_stations.no_photos') }}
                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="col-12 nopads" v-if="observationUpdate.geometry">
                            <button
                                class="btn btn-sm btn-primary form-button"
                                @click.stop="showDrawGeometryWizard = !showDrawGeometryWizard"
                            >
                                {{ $t('map.redefine_geometry') }}
                            </button>
                    </div>
                    <hr/>
                    <comment-container
                        :topic="commentTopics.TOPIC_OBSERVATIONS"
                        :id="observationUpdate.id"
                        :user="user"
                    />
                    <hr/>
                    <h4 class="form-header pl-3 pr-4">{{ $t('contracts.basic_info')}}</h4>
                    <div class="row">
                        <div class="col-sm-6">
                            <span class="span-title">{{ $t("observations.reporter") }}</span>
                            <span v-if="observationUpdate.reporter">{{ observationUpdate.reporter.first_name }} {{ observationUpdate.reporter.last_name }}</span>
                            <span v-else>-</span>
                        </div>
                        <div class="col-sm-6">
                            <span class="span-title">{{ $t("observations.created_time") }}</span>
                            <span>{{ toLocalTime(observationUpdate.created_time) }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6" style="padding-top: .3em">
                            <open-contract-filter
                                :to="observationUpdate.created_time"
                                :from="now"
                                :show-company="false"
                                :show-title="true"
                                :showOnlyMyContractsOption="true"
                                :contract="observationUpdate.contract"
                                @loading="loading=true"
                                @loadingCompleted="loading=false"
                                @contractSelected="setContract"
                            />
                        </div>
                        <div class="col-sm-6 nopads">
                            <!-- order selection -->
                            <span class="span-title">{{ $t('observations.orders') }}</span>
                            <select
                                v-model="orderId"
                                class="form-select form-select-sm"
                                :disabled="orders.length < 1"
                            >
                                <option :value="null">
                                    {{ $t('observations.select_order') }}
                                </option>
                                <option
                                    v-for="option in orders"
                                    :key="option.id"
                                    :value="option.id"
                                >
                                    {{ getOrderStringWithInfo(option) }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <span class="span-title">{{ $t('observations.closed_time') }}</span>
                        <div class="col-sm-4 pt-1">
                            <date-time-picker
                                v-model:date="closedTime"
                                format="dd.MM.yyyy HH:mm"
                                :enableTimePicker="true"
                                :placeholder="$t('observations_videos.search_input_format')"
                            />
                        </div>
                        <div class="col-sm-2 text-end">
                            <button v-if="closedTime" class="btn btn-sm btn-outline-success form-button" @click="openObservation">
                                {{ $t('common.do_open') }}
                            </button>
                            <button v-else class="btn btn-sm btn-outline-primary form-button" @click="closeObservation">
                                {{ $t('common.close') }}
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <!-- Value -->
                        <div class="col-sm-6">
                            <div class="col-10 nopads">
                                <span class="span-title">{{ $t('observations.value') }}</span>
                                <input
                                    v-model="observationUpdate.value"
                                    type="number"
                                    step="any"
                                    class="form-control form-control-sm"
                                    :disabled="!(observationUpdate && observationUpdate.type && observationUpdate.type.numeric_info)"
                                />
                            </div>
                            <div class="col-2 nopads pl-2 text-center" style="padding-top: 1.8em">
                                {{ observationUpdate && observationUpdate.type && observationUpdate.type.numeric_unit ? observationUpdate.type.numeric_unit : '-' }}
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <span class="span-title">{{ $t('observation_list.archived') }}</span>
                            <input
                                class="form-check-input"
                                v-model="observationUpdate.archived"
                                type="checkbox"
                            >
                            <label for="checkbox" class="ms-2">{{ $t('observation_list.archived_hint') }}</label>
                        </div>
                    </div>

                    <!-- Info -->
                    <div class="col-sm-12">
                        <span class="span-title">{{ $t('work_time.note') }}</span>
                        <textarea
                            v-model="observationUpdate.info"
                            class="form-control form-control-sm"
                            :placeholder="$t('work_time.note')"
                            rows="4"
                        />
                    </div>

                    <hr/>
                    <div class="nopads" v-if="allowExternalEquipments">
                        <h4 class="form-header pl-3 pr-4">{{ $t('observations.external_equipment')}}</h4>
                        <div class="row pt-2">
                            <div class="col-sm-5">
                                <span class="span-title">{{ $t('observations.external_equipment') }}</span>
                                <span class="item-detail-text">{{ observationUpdate.external_system_equipment_id ?  observation.external_system_equipment_id : '-'}}</span>
                            </div>
                            <div class="col-sm-5">
                                <span class="span-title">{{ $t('observations.external_system') }}</span>
                                <span class="item-detail-text">{{ observationUpdate.external_system_id ?  getExternalSystemName(observation.external_system_id) : '-'}}</span>
                            </div>
                            <div class="col-sm-2 pt-4 text-end">
                                <button
                                    v-if="allowCancel"
                                    class="btn btn-sm btn-outline-primary form-button"
                                    @click.stop="searchEquipment"
                                >
                                    {{ $t('common.search') }}
                                </button>
                            </div>
                        </div>
                        <div v-if="externalEquipments.length > 0" class="col-12 nopads">
                            <external-equipment-selector
                                v-model="externalEquipment"
                                :equipments="externalEquipments"
                                :selected="observationUpdate.external_system_equipment_id"
                            />
                        </div>
                        <hr/>
                    </div>

                    <!-- Observation photo -->
                    <h4 class="form-header pl-3 pr-4">{{ $t('power_stations.photos')}}</h4>
                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="col-12">
                                <!-- Show selected photos -->
                                <div
                                    v-for="(file, index) in photos"
                                    :key="index"
                                    class="d-flex align-items-center justify-content-between mb-3"
                                >
                                    <span>{{ file?.name || file }}</span>
                                    <button
                                        class="btn btn-outline-danger btn-sm"
                                        type="button"
                                        @click="removePhoto(index)"
                                    >
                                        {{ $t('common.remove') }}
                                    </button>
                                </div>

                                <!-- Hidden file input -->
                                <file-drop-zone
                                    accept="image/jpeg,image/jpg,image/png"
                                    class="my-2"
                                    @files-selected="files => files.forEach(f => photos.push(f))"
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="observationUpdate && observationUpdate.id > 0 && allowAssign"
                        class="col-sm-12"
                    >
                        <hr/>
                        <work-assignment-view
                            :type="3"
                            :id="observationUpdate.id"
                            :can-edit="true"
                            :can-add="isObserver"
                            @editAssignment="editAssignment"
                        />
                    </div>
                </div>
                </main>
                <!-- Footer -->
                <footer class="flex-shrink-0 border-top">
                    <div class="col-sm-12 button-container">
                        <button
                            v-if="allowCancel"
                            class="btn btn-sm btn-secondary form-button"
                            @click.stop="close"
                        >
                            {{ $t('common.cancel') }}
                        </button>
                        <button
                            v-if="allowAssign"
                            :disabled="loading"
                            class="btn btn-sm btn-primary form-button"
                            @click.stop="showAssignment"
                        >
                            {{ workAssignment ? $t('work_assignment.edit') : $t('work_assignment.add') }}
                        </button>
                        <button
                            :disabled="loading"
                            class="btn btn-sm btn-success form-button"
                            @click.stop="submitObservation"
                        >
                            {{ $t('common.save') }}
                        </button>
                    </div>
                </footer>
            </div>
            <div
                v-if="loading"
                id="loader"
                class="spinner"
            />
        </div>

        <div
            v-if="isObserver && assignmentMode"
            class="col-sm-12 nopads"
            @click.stop="cancelClick($event)"
        >
            <work-assignment-editor
                v-if="isObserver && assignmentMode"
                :observation="observationUpdate"
                :is-observer="isObserver"
                :via-observation="true"
                :work-assignment="workAssignment"
                :dynamic="false "
                @close="setAssignmentEditorVisibility(false)"
                @closeAndUpdate="closeAndUpdate"
            />
        </div>
        <!-- Fullscreen photo -->
        <fullscreen-image
            v-if="fullScreenPhotoData"
            :save-disabled="false"
            :largeImages="fullScreenPhotoData"
            :photo-ids="fullScreenPhotoIds"
            :panelIndex="panelIndex"
            @close="closePhoto"/>
        </div>
    </base-modal>
</template>

<script>
import FileDropZone from '@/components/common/FileDropZone.vue'
import {restApi} from '../mixins/RestApiMixin'
import MarkerEditorMap from '../map/MarkerEditorMap'
import {mapHelper} from '../mixins/MapMixin'
import WorkAssignmentEditor from '../workassignment/WorkAssignmentEditor'
import WorkAssignmentView from '../workassignment/WorkAssignmentView'
import {attachmentHelper} from '../mixins/AttachmentMixin'
import {orderMixin} from "@/components/mixins/OrderMixin";
import {workAssignmentGeomTypes, workAssignmentHelper} from '../mixins/WorkAssignmentMixin'
import {observationHelper} from "@/components/mixins/ObservationMixin";
import DrawGeometryWizard from "@/components/shapeimport/DrawGeometryWizard";
import OpenContractFilter from "@/components/contract/OpenContractFilter";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";
import {getDistance} from 'geolib';
import ExternalEquipmentSelector from "@/components/velho/ExternalEquipmentSelector";
import FullscreenImage from "@/components/view/FullscreenImage";
import {timeUtils} from "@/components/mixins/TimeUtils";
import {Pagination} from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/pagination.css";
import "@egjs/vue3-flicking/dist/flicking.css";
import Flicking from "@egjs/vue3-flicking";
import ImageView from "@/components/view/ImageView.vue";
import RoadAddessView from "@/components/velho/RoadAddressView";
import {commentTopics} from "@/components/mixins/CommentMixin";
import CommentContainer from "@/components/comments/CommentContainer.vue";
import DateTimePicker from "@/components/common/DateTimePicker";
import {inject, nextTick} from "vue";
import BaseModal from "@/components/BaseModal";
import GoogleStreetViewLink from "@/components/utils/GoogleStreetViewLink";
import { Arrow } from "@egjs/flicking-plugins"
import EditorItemBrowser from "../common/EditorItemBrowser.vue";

export default  {
    name: 'ObservationEditor',
    components: {
        EditorItemBrowser,
        GoogleStreetViewLink,
        BaseModal,
        CommentContainer,
        RoadAddessView,
        Flicking,
        ImageView,
        FullscreenImage,
        ExternalEquipmentSelector,
        OpenContractFilter,
        MarkerEditorMap,
        WorkAssignmentEditor, WorkAssignmentView, DrawGeometryWizard,
        DateTimePicker,
        FileDropZone
    },
    mixins: [restApi, mapHelper, attachmentHelper, orderMixin, observationHelper, workAssignmentHelper,
        workAssignmentGeomTypes, conversionModelHelper, timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        },
        isObserver: Boolean,
        allowCancel: {
            type: Boolean,
            default: function () {
                return true
            }
        },
        viaWorkAssignment: {
            type: Boolean,
            default: false
        },
        oldWorkAssignment: {
            type: Object,
            default: null
        },
        allowAssign: {
            type: Boolean,
            default: function () {
                return true
            }
        },
        observation: {
            type: Object,
            default: null
        },
        index: {
            type: Number,
            default: null
        },
        itemCount: {
            type: Number,
            default: null
        },
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    emits: ['close', 'closeAndUpdate', 'nextItem', 'previousItem', 'toggleObservationSelection'],
    data() {
        return {
            options: {
                preventDefaultOnDrag: true,
                circular: true
            },
            plugins: [
                new Arrow(),
                new Pagination({ type: 'bullet' })
            ],
            loading: false,
            observationUpdate: null,
            contracts: [],
            orders: [],
            fullScreenPhotoData: null,
            fullScreenPhotoIds: [],
            closedTime: null,
            typeFilter: null,
            types: [],
            groups: [],
            externalEquipments: [],
            externalEquipment: null,
            open: false,
            allowExternalEquipments: false,
            group: null,
            orderId: null,
            contract: null,
            photos: [],
            showDrawGeometryWizard: false,
            userDefinedGeometry: false,
            assignmentMode: false,
            workAssignment: null,
            panelIndex: 0
        }
    },
    computed: {
        commentTopics() {
            return commentTopics
        },
        now() {
            return new Date().toISOString();
        }
    },
    watch: {
        assignmentMode(val) {
            if (val) {
                nextTick(() => this.$refs.content.scrollTo({ top: 0, behavior: 'smooth' }))
            }
        },
        group(val) {
            if (val && !(this.observations && this.observations.length === 1)) {
                this.fetchObsTypes()
            }
        },
        contract: function () {
            this.observationUpdate.contract = this.contract
            if (this.observationUpdate.contract) {
                this.allowExternalEquipments = this.contract.external_contract_id
                this.fetchOrders()
            } else {
                this.orders = []
                this.allowExternalEquipments = false
            }
        },
        'observationUpdate.geometry': {
            handler() {
                if (this.$refs.markerEditorMap) {
                    this.$nextTick(() => {
                        this.$refs.markerEditorMap.initView();
                    });
                }
            },
            deep: true
        },
        orderId() {
            if (this.orderId) {
                this.observationUpdate.work_order = {id: this.orderId}
            } else {
                this.observationUpdate.work_order = null
            }
        },
        externalEquipment(val) {
            this.observationUpdate.external_system_id = val ? val.system : null
            this.observationUpdate.external_system_equipment_id = val? val.id : null
        }
    },
    created: function () {
        if (this.observation) {
            this.observationUpdate = this.observation
            this.contract = this.observationUpdate.contract
            this.orderId = this.observationUpdate.work_order ? this.observationUpdate.work_order.id : null
            if(this.observationUpdate.type && this.observationUpdate.type.observation_group) {
                this.group = this.observationUpdate.type.observation_group.id
            }
            if (this.observationUpdate.closed_time) {
                // Ensure closed_time has timezone info so DateTimePicker interprets it correctly
                this.closedTime = this.observationUpdate.closed_time.indexOf('+') < 0 && this.observationUpdate.closed_time.indexOf('Z') < 0
                    ? this.observationUpdate.closed_time + '+00:00'
                    : this.observationUpdate.closed_time
            }
        } else {
            this.observationUpdate = {
                id: 0,
                type: null,
            }
        }
        this.getGeometryType()
        this.fetchObsGroups()
        if (this.contract) {
            this.allowExternalEquipments = this.contract.external_contract && this.contract.external_contract.id
        }
    },
    methods: {
        openObservation() {
            this.observationUpdate.closed_time = null
            this.closedTime = null
        },
        closeObservation() {
           this.closedTime = new Date(new Date().getTime() - 60 * 1000)
        },
        triggerPhotoInput() {
            this.$refs.photoInput?.click();
        },
        handleSelectionToggle() {
            this.$emit('toggleObservationSelection', this.observationUpdate)
        },
        handlePhotoChange(event) {
            Array.from(event.target.files).forEach(file => this.photos.push(file));
            event.target.value = '';
        },
        removePhoto(index) {
            this.photos.splice(index, 1);
        },
        fetchObsGroups: function () {
            this.groups = []
            this.loading = true
            this.restFetch(this.observationGroupUrl, this.handleGroupResponse)
        },
        handleGroupResponse: function (response) {
            this.groups = response.data
            this.loading = false
        },
        fetchObsTypes: function () {
            this.type = null
            this.types = []
            this.loading = true
            this.restFetchParams(this.observationTypeUrl, {group: this.group, geometry_type: this.typeFilter}, this.handleTypeResponse)
        },
        handleTypeResponse: function (response) {
            this.types = response.data
            this.loading = false
        },

        getGeometryType() {
            if(this.oldWorkAssignment) {
                this.typeFilter = this.getWorkAssignmentGeometryType(this.oldWorkAssignment)
            } else if(this.observationUpdate) {
                this.typeFilter = this.getObservationGeometryType(this.observationUpdate)
            }
        },

        setContract: function (contract) {
            this.contract = contract
        },
        fetchOrders: function () {
            this.order = null
            this.loading = true
            var params = {}
            if (this.observationUpdate.contract) {
                params.contract = this.observationUpdate.contract.id
            }
            params.open = 1 // Get orders only for
            // open or in progress contracts
            this.restFetchParams(this.orderUrl, params, this.handleOrders)
        },
        handleOrders: function (response) {
            this.orders = response.data
            this.loading = false
        },
        submitObservation: function () {
            this.loading = true
            if (this.closedTime) {
                // closedTime is already an ISO string (from DateTimePicker or server), don't re-convert
                this.observationUpdate.closed_time = this.closedTime
            }
            if (this.observation.id && this.observation.id > 0) {
                this.restUpdate(this.observationUrl, this.observationUpdate, this.success, this.fail)
            } else {
                this.restAdd(this.observationUrl, this.observationUpdate, this.success, this.fail)
            }
        },
        success: function (response) {
            // TODO: this is one part of the issue. save the observations location and set zoom level for the roadreportmap
            if(response && response.id || response !== 'ok') {
                this.observationUpdate = response.id ? response : null
            }
            var photos = this.getValidAttachments(this.photos)
            if (photos.length > 0 && this.observation) {
                this.uploadPhoto(photos)
            } else {
                this.loading = false
                this.$emit('closeAndUpdate', this.observation)
            }
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        },
        close: function () {
            this.assignmentMode = false
            this.$emit('close')
        },
        uploadPhoto: function (photos) {
            if (photos.length > 0) {
                this.loading = true
                let formData = new FormData()
                formData.append('observation_id', this.observation.id)
                photos.forEach(photoFile => {
                    if (photoFile !== undefined && photoFile !== null) {
                        formData.append('photos[]', photoFile)
                    }
                })
                this.restPostWithFile(this.observationPhotoUrl, {}, formData, this.photoSuccess, this.fail)
            }
        },
        photoSuccess: function () {
            this.loading = false
            this.$emit('closeAndUpdate', this.observation)
        },
        cancelClick: function (e) {
            e.stopPropagation()
        },
        showAssignment() {
            this.editAssignment(this.workAssignment)
        },
        editAssignment: function (assignment) {
            if(this.allowAssign) {
                this.workAssignment = assignment
                this.setAssignmentEditorVisibility(true)
            } else {
                this.$emit('close')
            }
        },
        setAssignmentEditorVisibility: function (visible) {
            this.assignmentMode = visible
        },
        addGeometryToObservation(geometry) {
            if (!geometry) {
                this.showAlert(this.$t('common.alert_update_failed'))
                return;
            }
            if(geometry && geometry.point && geometry.point.lat && geometry.point.lon) {
                this.observationUpdate.geometry = {point: {y: geometry.point.lat, x: geometry.point.lon}}
            } else if(geometry.line_string && geometry.line_string.points) {
                this.observationUpdate.geometry = geometry
            }
            this.closeDrawGeometryWizard()
            this.userDefinedGeometry = true
        },
        closeDrawGeometryWizard() {
            this.showDrawGeometryWizard = false
        },
        closeAndUpdate: function (assignment) {
            this.setAssignmentEditorVisibility(false)
            this.workAssignment = assignment
        },
        searchEquipment() {
            const params = {
                lat: this.observationUpdate.geometry.point.y,
                lon: this.observationUpdate.geometry.point.x
            }
            this.loading = true
            this.restFetchParams(this.extEquipmentSearchUrl, params, this.handleEquipments)
        },
        handleEquipments(response) {
            this.loading = false
            if (response && response.data) {
                this.initEquipmentOptions(response.data)
            } else {
                this.externalEquipments = []
            }
        },
        initEquipmentOptions(data) {
            this.externalEquipments = []
            const tempResults = []
            const keys = Object.keys(data)
            keys.forEach(key => {
                const items = data[key]
                const type = this.getTypeCodeForKey(key)
                items.forEach(eq => {
                    tempResults.push({
                        "id": eq.external_system_id,
                        "type": type,
                        "system": eq.external_system,
                        "name": this.getEquipmentTypeName(type),
                        "code": eq.sign ? eq.sign : null,
                        "distance": eq.position ? getDistance(
                            {latitude: this.observationUpdate.geometry.point.x,longitude: this.observationUpdate.geometry.point.y},
                            {latitude: eq.position.x,longitude: eq.position.y}) : null
                        })
                })
            })
            tempResults.sort((a, b) => {
                if (a.distance === null && b.distance === null) {
                    return 0; // If both are null, consider them equal
                } else if (a.distance === null) {
                    return 1; // Null should come after non-null values
                } else if (b.distance === null) {
                    return -1; // Null should come after non-null values
                } else {
                    return a.distance - b.distance; // Sort based on the numeric attribute
                }
            });
            this.externalEquipments = tempResults
        },
        openImage: function () {
            const flicking = this.$refs.flicking
            const imageData = this.$refs.image
            this.fullScreenPhotoData = []
            this.fullScreenPhotoIds = []

            imageData.forEach((src, index) => {
                this.fullScreenPhotoData.push(src)
                this.fullScreenPhotoIds.push(this.observationUpdate.photos[index].id)
            })
            this.panelIndex = flicking.index

        },
        closePhoto() {
            this.fullScreenPhotoData = null
        }
    }
}
</script>
<style scoped>
.map-container {
    height: 30em;
    position: relative;
}

.flicking-panel {
    display: flex;
    position: relative;
    justify-content: center;
    overflow: hidden;
    flex-direction: column;
    align-items: center;
    height: 100%; /* Full height of the Flicking container */
    width: 100%; /* Full width of the Flicking container */
}

.flicking-panel-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain; /* Ensures image fits within the container and is fully visible */
}


.flicking-pagination-bullets-container {
    position: absolute;
    bottom: .5rem;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 10;
}


</style>

